export enum VerificationStatusEnum {
  PENDING = "PENDING",
  SUCCESS = "APPROVE",
  DECLINED = "DECLINED",
  CREATED = "CREATED",
}
